<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.cartoonCode ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="资源标题" prop="cartoonName">
          <el-input v-model="dataForm.cartoonName" placeholder="资源标题"></el-input>
      </el-form-item>
          <el-form-item label="电影摘要" prop="cartoonIntroduce">
          <el-input v-model="dataForm.cartoonIntroduce" placeholder="电影摘要"></el-input>
      </el-form-item>
          <el-form-item label="收费类型" prop="cartoonVip">
          <el-radio-group v-model="dataForm.cartoonVip">
              <el-radio :label="0">免费</el-radio>
              <el-radio :label="1">收费</el-radio>
            </el-radio-group>
      </el-form-item>
      <el-form-item label="是否精选" prop="isFeatured">
          <el-radio-group v-model="dataForm.isFeatured">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
      </el-form-item>
          <el-form-item label="资源详情图" prop="cartoonImage">
           <ImageUpload :limit="1"
          v-model="dataForm.cartoonImage"
          :file-size="5"
          :file-type="['png', 'jpg', 'jpeg', 'gif','webp']"
          :is-show-tip="true"
        />
      </el-form-item>
          <el-form-item label="更新详情" prop="cartoonAuthor">
          <el-input v-model="dataForm.cartoonAuthor" placeholder="已完结或者更新到多少集"></el-input>
      </el-form-item>
          <el-form-item label="评分" prop="cartoonScore">
          <el-input v-model="dataForm.cartoonScore" placeholder="评分"></el-input>
      </el-form-item>
      <el-form-item label="全集价钱" prop="moviesPrice">
          <el-input v-model="dataForm.moviesPrice" placeholder="全集价钱(金币)"></el-input>
      </el-form-item>
      <el-form-item label="单集价钱" prop="onePrice">
          <el-input v-model="dataForm.onePrice" placeholder="单集价钱(金币)"></el-input>
      </el-form-item>
      <el-form-item label="热度" prop="cartoonHot">
          <el-input v-model="dataForm.cartoonHot" placeholder="热度"></el-input>
      </el-form-item>
          <el-form-item label="所属分类" prop="dictCode">
          <el-select v-model="dataForm.dictCode" placeholder="请选择父分类" @change="seleClass()">
            <el-option
              v-for="item in pDict"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
      </el-form-item>
          <el-form-item label="所属子分类" prop="sonDictCode">
          <el-select v-model="dataForm.sonDictCode" placeholder="请选择父分类">
            <el-option
              v-for="item in sonDict"
              :key="item.dictCode"
              :label="item.dictName"
              :value="item.dictCode">
            </el-option>
          </el-select>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<script>
import debounce from 'lodash/debounce'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      visible: false,
      type: 0,
      pDict: [],
      sonDict: [],
      dataForm: {
        cartoonCode: '',
        cartoonName: '',
        cartoonIntroduce: '',
        cartoonVip: '',
        cartoonImage: '',
        cartoonAuthor: '',
        cartoonScore: '',
        dictCode: '',
        moviesPrice: '',
        isFeatured: '',
        onePrice: '',
        cartoonHot: '',
        sonDictCode: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        cartoonName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cartoonIntroduce: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cartoonVip: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        cartoonImage: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        
        cartoonScore: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        dictCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        sonDictCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.getpDict()
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.cartoonCode) {
          this.getInfo()
        } else {
          // 新增时清空图片数据
          this.dataForm.cartoonImage = ''
          this.sonDict = []
        }
      })
    },
   seleClass(){
    this.dataForm.sonDictCode = ''
    this.getSonDict(this.dataForm.dictCode)
   },
    // 获取信息
    getInfo () {
      this.$http.get(`/movies/movies/${this.dataForm.cartoonCode}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.getSonDict(this.dataForm.dictCode)
      }).catch(() => {})
    },
    getpDict() {
      this.$http.get(`/sondict/sondict/getpDict/${this.type}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.pDict = res.data
      }).catch(() => {})
    },
    getSonDict(dictCode) {
      this.$http.get(`/sondict/sondict/getpSonDict/`+dictCode).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.sonDict = res.data
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.cartoonIntroduce = encodeURIComponent(this.dataForm.cartoonIntroduce )
        this.$http[!this.dataForm.cartoonCode ? 'post' : 'put']('/movies/movies/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
